<template>
    <div id="compass">
        <div v-show="!moving && myCityMap.id">
            <div id="northwest" ref="northwest" @click="moveto('northwest', myCityMap.northwest);"></div>
            <div id="north" ref="north" @click="moveto('north', myCityMap.north);"></div>
            <div id="northeast" ref="northeast" @click="moveto('northeast', myCityMap.northeast);"></div>
            <div id="west" ref="west" @click="moveto('west', myCityMap.west);"></div>
            <div id="center" ref="center" @click="moveto('center', myCityMap.center);"></div>
            <div id="east" ref="east" @click="moveto('east', myCityMap.east)"></div>
            <div id="southwest" ref="southwest" @click="moveto('southwest', myCityMap.southwest);"></div>
            <div id="south" ref="south" @click="moveto('south', myCityMap.south);"></div>
            <div id="southeast" ref="southeast" @click="moveto('southeast', myCityMap.southeast);"></div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'compass',
  data() {
    return {
        myCityMap: {
            id: null,
            northwest: null, north: null, northeast: null,
            west: null, center: null, east: null,
            southwest: null, south: null, southeast: null
        }
    };
  },
  computed: {
    ...mapState('street', ['cityMap', 'moving'])
  },
  watch: {
      cityMap: {
        handler(newVal) {
          if (newVal != null && newVal.id != null) {
            this.initCompass(newVal);
          }
        },
        immediate: true
      }
  },
  methods: {
    initCompass: function(myCityMap, retry) {
        if (!myCityMap) return;
        this.myCityMap.id = myCityMap.id;
        // 确保 $refs 已渲染。原来是无条件 $nextTick 自递归 —— 一旦罗盘被 v-if
        // 移出/替换、$refs 长期取不到，就会每个 tick 递归一次无限空转（主线程持续被占）。
        // 现在最多等 3 个 tick，取不到就放弃，等下一次 cityMap 变化再重试。
        if (!this.$refs.northwest) {
          retry = retry || 0;
          if (retry >= 3) return;
          this.$nextTick(() => { this.initCompass(myCityMap, retry + 1); });
          return;
        }
        if (myCityMap.northwest != null && myCityMap.northwest != 0) {
            this.$refs.northwest.style.display = 'block';
            this.myCityMap.northwest = myCityMap.northwest;
        } else {
            this.$refs.northwest.style.display = 'none';
        }
        if (myCityMap.north != null && myCityMap.north != 0) {
            this.$refs.north.style.display = 'block';
            this.myCityMap.north = myCityMap.north;
        } else {
            this.$refs.north.style.display = 'none';
        }
        if (myCityMap.northeast != null && myCityMap.northeast != 0) {
            this.$refs.northeast.style.display = 'block';
            this.myCityMap.northeast = myCityMap.northeast;
        } else {
            this.$refs.northeast.style.display = 'none';
        }
        if (myCityMap.west != null && myCityMap.west != 0) {
            this.$refs.west.style.display = 'block';
            this.myCityMap.west = myCityMap.west;
        } else {
            this.$refs.west.style.display = 'none';
        }
        if (myCityMap.east != null && myCityMap.east != 0) {
            this.$refs.east.style.display = 'block';
            this.myCityMap.east = myCityMap.east;
        } else {
            this.$refs.east.style.display = 'none';
        }
        if (myCityMap.southwest != null && myCityMap.southwest != 0) {
            this.$refs.southwest.style.display = 'block';
            this.myCityMap.southwest = myCityMap.southwest;
        } else {
            this.$refs.southwest.style.display = 'none';
        }
        if (myCityMap.south != null && myCityMap.south != 0) {
            this.$refs.south.style.display = 'block';
            this.myCityMap.south = myCityMap.south;
        } else {
            this.$refs.south.style.display = 'none';
        }
        if (myCityMap.southeast != null && myCityMap.southeast != 0) {
            this.$refs.southeast.style.display = 'block';
            this.myCityMap.southeast = myCityMap.southeast;
        } else {
            this.$refs.southeast.style.display = 'none';
        }
    },
    moveto: function(direction, id) {
        if (!id || this.moving) return;
        this.$store.dispatch('street/moveTo', {targetId: id, direction: direction});
    }
  }
}
</script>

<style scoped>
#compass {
	width:120px;
	height:126px;
	float:left;
	background-image:url("/oss/action.gif");
    background-size:120px 126px;
    -moz-background-size:120px 126px;
	position:relative;
}
#compass div div {
	width:40px;
	height:42px;
	position:absolute;
	display:none;
	cursor:pointer;
	background:url("/oss/action2.gif") no-repeat; 
    background-size:120px 126px;
    -moz-background-size:120px 126px;
	overflow:hidden;
}
#compass #northwest {
	top:0px;
	left:0px;
	background-position:0px 0px;
}
#compass #north {
	top:0px;
	left:40px;
	background-position:-40px 0px;
}
#compass #northeast {
	top:0px;
	left:80px;
	background-position:-80px 0px;
}

#compass #west {
	top:42px;
	left:0px;
	background-position:0px -42px;
}
#compass #east {
	top:42px;
	left:80px;
	background-position:-80px -42px;
}

#compass #southwest {
	top:84px;
	left:0px;
	background-position:0px -84px;
}
#compass #south {
	top:84px;
	left:40px;
	background-position:-40px -84px;
}
#compass #southeast {
	top:84px;
	left:80px;
	background-position:-80px -84px;
}

/* ========== 移动端：融入底栏居中格 ========== */
@media (max-width: 768px) {
  #compass {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -60px;
    /* -63px 时罗盘视觉底边伸到视口底 ~5px，压进底部经验条（0~14px）区，
       上提 13px 让底边收到经验条上方（2026-10-02） */
    margin-top: -76px;
    transform: scale(0.9);
    transform-origin: center center;
    float: none;
    z-index: 3;
  }
}
</style>
